import {Values} from "@wix/devzai-utils-common";
import {WixPremiumFeaturesSpec, WixPremiumFeatureType} from "@wix/devzai-common-wix";

export const DoppeAllSupportedPremiumFeatures = {
    identity_collaborators: 'identity_collaborators',
    hopp_remove_banner: 'hopp_remove_banner',
    hopp_latest_items_action: 'hopp_latest_items_action',
    hopp_on_page_display: 'hopp_on_page_display',
    hopp_indexed_links_in_search: 'hopp_indexed_links_in_search',
    hopp_search_shortcuts: 'hopp_search_shortcuts',
    hopp_contact_management: 'hopp_contact_management',
    hopp_banner_display: 'hopp_banner_display',
    creators_favicon_: 'creators_favicon_',
    hopp_ai_media: 'hopp_ai_media',
    hopp_automations: 'hopp_automations',
    creators_pre_rolls_count: 'creators_pre_rolls_count',
    connect_your_domain: 'connect_your_domain',
    hopp_verified_badge: 'hopp_verified_badge',
    hopp_full_screen_view: 'hopp_full_screen_view',
    hopp_add_items_to_list_action: 'hopp_add_items_to_list_action',
    hopp_unlimited_pages: 'hopp_unlimited_pages',
    hopp_contacts_subscription_action: 'hopp_contacts_subscription_action',
    hopp_marketing_pixels: 'hopp_marketing_pixels',
    creators_advanced_search_settings: 'creators_advanced_search_settings',
    hopp_pre_roll_limits: 'hopp_pre_roll_limits',
    hopp_hopp: 'hopp_hopp',
    hopp_brand_redirects: 'hopp_brand_redirects',
    hopp_meta_pixel: 'hopp_meta_pixel',
    hopp_import_links_from_youtube: 'hopp_import_links_from_youtube',
    hopp_has_pro_subscription: 'hopp_has_pro_subscription',
    hopp_crm_integration_wix: 'hopp_crm_integration_wix',
    hopp_list_premium_styles: 'hopp_list_premium_styles',
    hopp_customize_privacy_policy: 'hopp_customize_privacy_policy',
    hopp_advanced_design_options: 'hopp_advanced_design_options',
    creators_monetization_actions: 'creators_monetization_actions',
    hopp_allow_connect_subdomain: 'hopp_allow_connect_subdomain',
    hopp_full_analytics: 'hopp_full_analytics',
    hopp_allow_pre_rolls: 'hopp_allow_pre_rolls',
    hopp_allow_landing_pages: 'hopp_allow_landing_pages',
    hopp_shortened_links_bulk_actions: 'hopp_shortened_links_bulk_actions',
    hopp_phone_number_collection: 'hopp_phone_number_collection',
    hopp_advanced_page_presets: 'hopp_advanced_page_presets',
    creators_form_submission: 'creators_form_submission',
    creators_social_analytics: 'creators_social_analytics',
    hopp_allow_short_links: 'hopp_allow_short_links',
    hopp_change_link_destination: 'hopp_change_link_destination',
    media_storage_total: 'media_storage_total',
    hopp_custom_terms_and_conditions: 'hopp_custom_terms_and_conditions',
    hopp_subdomain_edits: 'hopp_subdomain_edits',
    hopp_bulk_connect_to_pre_roll: 'hopp_bulk_connect_to_pre_roll',
    hopp_create_short_links: 'hopp_create_short_links',
    hopp_seo_settings: 'hopp_seo_settings',
    hopp_social_share_settings_editing: 'hopp_social_share_settings_editing',
    hopp_lock_action: 'hopp_lock_action',
    hopp_google_analytics: 'hopp_google_analytics',
    stores_usps_discount: 'stores_usps_discount',
    analytics_custom_reports: 'analytics_custom_reports',
    restaurants_orders: 'restaurants_orders',
    bookings_service_list: 'bookings_service_list',
    bandwidth: 'bandwidth',
    accept_payments_on_form: 'accept_payments_on_form',
    events_sell_tickets: 'events_sell_tickets',
    bookings_video_conferencing: 'bookings_video_conferencing',
    photography_sell_photo: 'photography_sell_photo',
    velo_allocated_memory_per_container: 'velo_allocated_memory_per_container',
    hotels_online_reservations: 'hotels_online_reservations',
    signature_field: 'signature_field',
    customized_favicon: 'customized_favicon',
    file_downloads: 'file_downloads',
    hotels_channel_manager: 'hotels_channel_manager',
    velo_job_scheduler_number_of_jobs: 'velo_job_scheduler_number_of_jobs',
    velo_max_containers: 'velo_max_containers',
    velo_allocated_cpu_per_container: 'velo_allocated_cpu_per_container',
    media_storage: 'media_storage',
    velo_business_events: 'velo_business_events',
    stores_sales_channel_amazon: 'stores_sales_channel_amazon',
    velo_backend_request_timeout: 'velo_backend_request_timeout',
    stores_subscription: 'stores_subscription',
    loyalty_points_expiration: 'loyalty_points_expiration',
    create_recurring_payments: 'create_recurring_payments',
    restaurants_menus: 'restaurants_menus',
    google_analytics: 'google_analytics',
    wix_sms_number_of_messages: 'wix_sms_number_of_messages',
    video_duration: 'video_duration',
    hopp_connect_payments_by_wix_on_hopp_met: 'hopp_connect-payments-by-wix-on-hopp-met',
    loyalty_wix_loyalty_program: 'loyalty_wix_loyalty_program',
    multiple_category_pages: 'multiple_category_pages',
    scheduled_chat_hours: 'scheduled_chat_hours',
    ecom_automated_discounts: 'ecom_automated_discounts',
    remove_wix_ads: 'remove_wix_ads',
    bookings_payments: 'bookings_payments',
    online_stores_pre_order_ecom: 'online_stores_pre_order_ecom',
    online_stores_product_recommendations: 'online_stores_product_recommendations',
    custom_fields: 'custom_fields',
    ecom_platform_additonal_fees_spi: 'ecom_platform_additonal_fees_spi',
    velo_business_spis: 'velo_business_spis',
    rise_gift_card_ecom: 'rise_gift_card_ecom',
    multiple_product_pages: 'multiple_product_pages',
    customizable_forms: 'customizable_forms',
    hotels_google_ads: 'hotels_google_ads',
    velo_database_type: 'velo_database_type',
    max_emails_on_form: 'max_emails_on_form',
    loyalty_tiers_under_wix_loyalty_program: 'loyalty_tiers_under_wix_loyalty_program',
    booking_resource_management_type: 'booking_resource_management_type',
    bookings_staff_limit: 'bookings_staff_limit',
    pricing_plans_accept_payments: 'pricing_plans_accept_payments',
    stores_back_in_stock_alerts: 'stores_back_in_stock_alerts',
    currency_converter: 'currency_converter',
    single_video_duration: 'single_video_duration',
    hotels_localization: 'hotels_localization',
    hopp_desktop_layout: 'hopp_desktop_layout',
    invoices_accept_payments: 'invoices_accept_payments',
    forms_conditional_forms: 'forms_conditional_forms',
    restaurants_reservations: 'restaurants_reservations',
    stores_sales_channel_ebay: 'stores_sales_channel_ebay',
    velo_job_scheduler_min_interval: 'velo_job_scheduler_min_interval',
    bookings_courses: 'bookings_courses',
    automations: 'automations',
    custom_steps: 'custom_steps',
    ecom_platform_catalog_spi: 'ecom_platform_catalog_spi',
    velo_collections_limit: 'velo_collections_limit',
    bookings_sms_reminders: 'bookings_sms_reminders',
    bookings_appointments: 'bookings_appointments',
    avalara_tax_calculation: 'avalara_tax_calculation',
    accept_payments: 'accept_payments',
    velo_backend_requests_qouta: 'velo_backend_requests_qouta',
    bookings_resource_management_item_limitation: 'bookings_resource_management_item_limitation',
    bookings_groups: 'bookings_groups',
    loyalty_wix_referral_program: 'loyalty_wix_referral_program',
    velo_indexes: 'velo_indexes',
    velo_write_rpm: 'velo_write_rpm',
    ecom_platform_shipping_labels_discounts: 'ecom_platform_shipping_labels_discounts',
    wix_pos_point_of_sale: 'wix_pos_point_of_sale',
    hopp_install_business_tpa_on_hopp_meta_s: 'hopp_install-business-tpa-on-hopp-meta-s',
    online_programs_program_participation: 'online_programs_program_participation',
    velo_external_database_collections: 'velo_external_database_collections',
    hopp_enable_blog: 'hopp_enable_blog',
    events_no_footer_in_email: 'events_no_footer_in_email',
    restaurants_table_reservations: 'restaurants_table_reservations',
    bookings_external_calendars: 'bookings_external_calendars',
    moto_moto: 'moto_moto',
    live_video_duration: 'live_video_duration',
    file_upload_field: 'file_upload_field',
    ecom_platform_deposit_ecom: 'ecom_platform_deposit_ecom',
    velo_single_operation_processing_time: 'velo_single_operation_processing_time',
    velo_dedicated_collections: 'velo_dedicated_collections',
    stores_basic_premium: 'stores_basic_premium',
    vip_support: 'vip_support',
    velo_storage_rows: 'velo_storage_rows',
    ecom_platform_shipping_spi: 'ecom_platform_shipping_spi',
    events_url_in_email: 'events_url_in_email',
    bookings_reminders: 'bookings_reminders',
    velo_read_rpm: 'velo_read_rpm',
    stores_multiple_checkout_currencies: 'stores_multiple_checkout_currencies',
    remove_ascend_branding: 'remove_ascend_branding',
    marketing_tools_post_scheduling: 'marketing_tools_post_scheduling',
    marketing_tools_social_analytics: 'marketing_tools_social_analytics',
    total_monthly_emails: 'total_monthly_emails',
    emails_multiple_sender_details: 'emails_multiple_sender_details',
    marketing_tools_publish_stories: 'marketing_tools_publish_stories',
    marketing_tools_published_social_posts: 'marketing_tools_published_social_posts',
    social_media_stories_publishing: 'social_media_stories_publishing',
    stores_legacy_premium: 'stores_legacy_premium',
    domain_sync: 'domain_sync',
    campaigns_per_month: 'campaigns_per_month',
    marketing_tools_ai_social_suggestions: 'marketing_tools_ai_social_suggestions',
    marketing_tools_social_accounts_connected: 'marketing_tools_social_accounts_connected',
    campaign_scheduling: 'campaign_scheduling',
} as const;

export type DoppeAllSupportedPremiumFeatures = Values<typeof DoppeAllSupportedPremiumFeatures>;

export const DoppeAllSupportedPremiumFeaturesSpec = {
    [DoppeAllSupportedPremiumFeatures.identity_collaborators]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_remove_banner]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_latest_items_action]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_on_page_display]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_indexed_links_in_search]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_search_shortcuts]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_contact_management]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_banner_display]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.creators_favicon_]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_ai_media]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_automations]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.creators_pre_rolls_count]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.connect_your_domain]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_verified_badge]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_full_screen_view]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_add_items_to_list_action]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_unlimited_pages]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_contacts_subscription_action]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_marketing_pixels]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.creators_advanced_search_settings]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_pre_roll_limits]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_hopp]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_brand_redirects]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_meta_pixel]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_import_links_from_youtube]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_has_pro_subscription]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_crm_integration_wix]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_list_premium_styles]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_customize_privacy_policy]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_advanced_design_options]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.creators_monetization_actions]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_allow_connect_subdomain]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_full_analytics]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_allow_pre_rolls]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_allow_landing_pages]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_shortened_links_bulk_actions]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_phone_number_collection]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_advanced_page_presets]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.creators_form_submission]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.creators_social_analytics]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_allow_short_links]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_change_link_destination]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.media_storage_total]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_custom_terms_and_conditions]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_subdomain_edits]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_bulk_connect_to_pre_roll]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_create_short_links]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_seo_settings]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_social_share_settings_editing]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_lock_action]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_google_analytics]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.stores_usps_discount]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.analytics_custom_reports]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.restaurants_orders]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.bookings_service_list]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.bandwidth]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.accept_payments_on_form]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.events_sell_tickets]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.bookings_video_conferencing]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.photography_sell_photo]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_allocated_memory_per_container]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hotels_online_reservations]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.signature_field]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.customized_favicon]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.file_downloads]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hotels_channel_manager]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_job_scheduler_number_of_jobs]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.velo_max_containers]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.velo_allocated_cpu_per_container]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.media_storage]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.velo_business_events]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.stores_sales_channel_amazon]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_backend_request_timeout]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.stores_subscription]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.loyalty_points_expiration]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.create_recurring_payments]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.restaurants_menus]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.google_analytics]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.wix_sms_number_of_messages]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.video_duration]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hopp_connect_payments_by_wix_on_hopp_met]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.loyalty_wix_loyalty_program]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.multiple_category_pages]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.scheduled_chat_hours]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.ecom_automated_discounts]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.remove_wix_ads]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.bookings_payments]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.online_stores_pre_order_ecom]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.online_stores_product_recommendations]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.custom_fields]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.ecom_platform_additonal_fees_spi]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_business_spis]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.rise_gift_card_ecom]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.multiple_product_pages]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.customizable_forms]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hotels_google_ads]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_database_type]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.max_emails_on_form]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.loyalty_tiers_under_wix_loyalty_program]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.booking_resource_management_type]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.bookings_staff_limit]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.pricing_plans_accept_payments]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.stores_back_in_stock_alerts]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.currency_converter]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.single_video_duration]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.hotels_localization]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_desktop_layout]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.invoices_accept_payments]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.forms_conditional_forms]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.restaurants_reservations]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.stores_sales_channel_ebay]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_job_scheduler_min_interval]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.bookings_courses]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.automations]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.custom_steps]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.ecom_platform_catalog_spi]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.velo_collections_limit]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.bookings_sms_reminders]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.bookings_appointments]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.avalara_tax_calculation]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.accept_payments]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_backend_requests_qouta]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.bookings_resource_management_item_limitation]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.bookings_groups]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.loyalty_wix_referral_program]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_indexes]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.velo_write_rpm]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.ecom_platform_shipping_labels_discounts]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.wix_pos_point_of_sale]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_install_business_tpa_on_hopp_meta_s]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.online_programs_program_participation]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_external_database_collections]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.hopp_enable_blog]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.events_no_footer_in_email]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.restaurants_table_reservations]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.bookings_external_calendars]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.moto_moto]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.live_video_duration]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.file_upload_field]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.ecom_platform_deposit_ecom]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.velo_single_operation_processing_time]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.velo_dedicated_collections]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.stores_basic_premium]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.vip_support]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_storage_rows]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.ecom_platform_shipping_spi]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.events_url_in_email]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.bookings_reminders]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.velo_read_rpm]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.stores_multiple_checkout_currencies]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.remove_ascend_branding]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.marketing_tools_post_scheduling]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.marketing_tools_social_analytics]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.total_monthly_emails]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.emails_multiple_sender_details]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.marketing_tools_publish_stories]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.marketing_tools_published_social_posts]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.social_media_stories_publishing]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.stores_legacy_premium]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.domain_sync]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.campaigns_per_month]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.marketing_tools_ai_social_suggestions]: WixPremiumFeatureType.Boolean,
    [DoppeAllSupportedPremiumFeatures.marketing_tools_social_accounts_connected]: WixPremiumFeatureType.Quota,
    [DoppeAllSupportedPremiumFeatures.campaign_scheduling]: WixPremiumFeatureType.Boolean,
} satisfies WixPremiumFeaturesSpec<DoppeAllSupportedPremiumFeatures>;